/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Flickity carousels (and a few other components) mark off-screen slides with aria-hidden="true" but don't
 * remove their interactive descendants (Add to Cart buttons, product links, etc.) from the tab order, so
 * keyboard/screen-reader users can still reach content that's visually hidden. Mirror aria-hidden onto the
 * native `inert` property, which handles both focus and accessibility-tree removal correctly.
 */
(function () {
  function syncInert(el) {
    var hidden = el.getAttribute('aria-hidden') === 'true';
    if ('inert' in el) {
      el.inert = hidden;
    }
  }

  document.querySelectorAll('[aria-hidden]').forEach(syncInert);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      syncInert(mutation.target);
    });
  }).observe(document.body, {
    attributes: true,
    attributeFilter: ['aria-hidden'],
    subtree: true
  });
})();

/**
 * The Multi-Location Stock Info app renders its list/map view-toggle buttons (#listViewBtn,
 * #mapViewBtn) without an accessible name, so screen readers just announce "button". We don't
 * control that app's markup, but the IDs are stable, so patch them from here. The widget can
 * inject its markup asynchronously, so watch for it rather than only checking once on load.
 */
(function () {
  function labelStoreAvailabilityToggles() {
    var listBtn = document.getElementById('listViewBtn');
    var mapBtn = document.getElementById('mapViewBtn');
    if (listBtn && !listBtn.hasAttribute('aria-label')) {
      listBtn.setAttribute('aria-label', 'List view');
    }
    if (mapBtn && !mapBtn.hasAttribute('aria-label')) {
      mapBtn.setAttribute('aria-label', 'Map view');
    }
  }

  labelStoreAvailabilityToggles();

  new MutationObserver(labelStoreAvailabilityToggles).observe(document.body, {
    childList: true,
    subtree: true
  });
})();

/**
 * .mobile-menu / .mini-cart (and other slide-out panels) are `position: absolute; top: 100%`
 * relative to the header, which is `position: relative` and sits in normal page flow near the
 * top of the document - it doesn't follow the viewport. If a panel opens while the page is
 * scrolled down, it renders off-screen near the top of the document instead of where the user
 * is looking, leaving what looks like a giant empty gap. theme.js already toggles a
 * `no-mobile-scroll` class on <body> whenever one of these panels opens/closes - scroll to the
 * top and lock the page there for as long as it's open, then restore the original scroll
 * position when it closes, so the panel is always positioned where it's actually visible.
 */
(function () {
  var savedScrollY = 0;
  var locked = false;

  function isMobile() {
    return window.matchMedia('(max-width: 640px)').matches;
  }

  function lock() {
    if (locked || !isMobile()) return;
    locked = true;
    savedScrollY = window.scrollY || window.pageYOffset || 0;

    if (savedScrollY > 0) {
      document.body.classList.add('was-scrolled-on-open');
      window.scrollTo(0, 0);
      // The mini-cart (and possibly other panels) size themselves based on window.scrollY at the
      // moment they open, before this class toggle is even seen - nudge them to recompute now
      // that we've moved the scroll position, using the resize listener they already have.
      window.dispatchEvent(new Event('resize'));
    }

    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

  function unlock() {
    if (!locked) return;
    locked = false;
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.classList.remove('was-scrolled-on-open');
    window.scrollTo(0, savedScrollY);
  }

  function sync() {
    if (document.body.classList.contains('no-mobile-scroll')) {
      lock();
    } else {
      unlock();
    }
  }

  sync();

  new MutationObserver(sync).observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });
})();

